/**
 * Public storefront query params (README.md Phase 19).
 */
import { z } from 'zod';
import { SHOP_CATEGORIES } from '../constants.js';
import { idSchema, paginationSchema } from './common.js';
export const listPublicShopsQuerySchema = paginationSchema.extend({
    area: z.string().max(120).optional(),
    city: z.string().max(120).optional(),
    category: z.enum(SHOP_CATEGORIES).optional(),
});
export const publicCatalogQuerySchema = paginationSchema.extend({
    search: z.string().max(120).optional(),
    categoryId: idSchema.optional(),
});
//# sourceMappingURL=storefront.js.map